import { notificationRepository } from 'repositories/notificationRepository';
import { notificationStatusModel } from 'models/NotificationStatusModel';
import articlesNotificationModel from 'models/ArticlesNotificationModel';
import systemNotificationModel from 'models/SystemNotificationModel';

class NotificationController {
    constructor() {
      this.cached = {
        articles: false,
        system: false,
      }
    }
    initCheckStatus() {
      this.request();
      this.intervalId = setInterval(this.request.bind(this),
        notificationRepository.getInterval());
    }
    checkStatus() {
      this.intervalId = setInterval(this.request.bind(this),
        notificationRepository.getInterval());
    }
    request() {
      notificationRepository.checkStatus().then((data) => {
        if (data.articles) {
          this.cached.articles = false;
          notificationStatusModel.setArticles(data.articles);
        }
        if (data.system) {
          this.cached.system = false;
          notificationStatusModel.setSystemNotification(data.system);
        }
      });
    }
    stopCheckingStatus() {
      window.clearInterval(this.intervalId);
      this.intervalId = null;
    }
    updateArticlesModel() {
      if (this.cached.articles !== false) {
        articlesNotificationModel.update(this.cached.articles);
        return Promise.resolve(this.cached.articles);
      }
      notificationRepository
        .checkArticlesNotifications()
        .then((data) => {
          articlesNotificationModel.update(data);
          this.cached.articles = data;
          return data;
        });
    }
    updateSystemModel() {
      if (this.cached.system !== false) {
        systemNotificationModel.update(this.cached.system);
        return Promise.resolve(this.cached.system);
      }
      return notificationRepository
        .checkSystemNotifications()
        .then((data) => {
          systemNotificationModel.update(data);
          this.cached.system = data;
          return data;
        });
    }
    /*
     * For ajax reload on the fly
     * - its not used now
     */
    loadNewSystemModel() {
      if (systemNotificationModel.isEnd()) {
        return Promise.resolve({ end: true });
      }
      const last = systemNotificationModel.getLast();
      return notificationRepository
        .checkSystemNotifications(last)
        .then((data) => {
          systemNotificationModel.load(data);
          return data;
        });
    }
}

const controller = new NotificationController();

export default controller;



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/login-bar/controller.js